import classNames from "classnames";
import React from "react";

type Props = { position?: "left" | "top" | "right" | "bottom" };

export const ArrowSvg: React.FC<Props> = ({ position = "left" }) => {
  const rotations = {
    left: "rotate-0",
    top: "rotate-90",
    right: "rotate-180",
    bottom: "-rotate-90",
  };

  return (
    <svg
      className={classNames("", rotations[position])}
      width={"20"}
      height={"20"}
      viewBox={"0 0 20 20"}
      fill={"none"}
      xmlns={"http://www.w3.org/2000/svg"}>
      <path
        d={
          "M6.52385 9.16658H16.6668V10.8332H6.52385L10.9938 15.3032L9.81533 16.4817L3.3335 9.99992L9.81533 3.51807L10.9938 4.69657L6.52385 9.16658Z"
        }
        fill={"currentColor"}
      />
    </svg>
  );
};
